export default __webpack_public_path__ + "static/la-sala-balthazaurus-scroll-672c53718ed1c3362935f276856fd3cf.mp4";